import React from 'react';
import { useParams } from 'react-router-dom';
import { DataTableActions } from 'src/components/DataTable';
import { isModalComplete } from 'src/components/ModalDialog';
import { useModal } from 'src/hooks';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore from '../../redux';
import { SolutionGroupItem } from '../../types';
import { useIsLastOwner } from '../hooks';
import { useSolutionUserRoles } from '../../hooks';
import SolutionGroupsEditModal from './SolutionGroupsEditModal';
import SolutionGroupsDeleteModal from './SolutionGroupsDeleteModal';

type Props = {
  item?: SolutionGroupItem;
};

function SolutionGroupsAction({ item }: Props) {
  const { solutionId } = useParams();
  const actions = useStoreUnitActions(solutionsStore);
  const { isValidSolutionOwner } = useSolutionUserRoles(solutionId);

  const onClose = (event, reason) =>
    isModalComplete(reason) && actions.groups(solutionId);

  const [EditDialog, handleEdit] = useModal(SolutionGroupsEditModal, {
    item,
    onClose,
  });

  const [DeleteDialog, handleDelete] = useModal(SolutionGroupsDeleteModal, {
    item,
    onClose,
  });

  return (
    <DataTableActions
      onEdit={handleEdit}
      onDelete={handleDelete}
      canDelete={isValidSolutionOwner}
      canEdit={isValidSolutionOwner}
    >
      {EditDialog}
      {DeleteDialog}
    </DataTableActions>
  );
}

export default SolutionGroupsAction;
